
export enum STATUS_PROMPT {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING', 
  FINISHED = 'FINISHED', 
  ERROR = 'ERROR', 
  ARCHIVED = 'ARCHIVED'
}